export default class AreaEditContenutiEdit {
    constructor(node) {
        this.node = node;
        this.editFormNode = this.node.querySelector('#edit-contenuto');
        this.fieldImgNode = this.editFormNode.querySelector('.field-img');
        this.fieldImgGalleryNode = this.editFormNode.querySelector('.field-img-gallery');
        
        this.addCKEditor();
        this.addListeners();
    }

    addListeners() {
        let _this = this;

        this.fieldImgNode.querySelector('[data-img-upload]').addEventListener('click', function(event) {
            event.preventDefault();
            _this.uploadImage();
        });

        if (window.cropToolEnabled) {
            this.fieldImgNode.querySelector('[data-img-crop]').addEventListener('click', function(event) {
                event.preventDefault();
                _this.cropImage();
            });
        }
        
        if (this.fieldImgGalleryNode) {
            this.fieldImgGalleryNode.querySelector('[data-img-gallery-upload]').addEventListener('click', function(event) {
                event.preventDefault();
                _this.uploadGalleryImage();
            });   
            
            this.fieldImgGalleryNode.addEventListener('click', function(event) {
                if (event.target.dataset.imgGalleryDelete !== undefined) {
                    event.preventDefault();
                    _this.deleteGalleryImage(event.target.dataset.imgGalleryDelete);
                }
            });
        }

        $(this.editFormNode).validate({
            callbackHandler: function (data, form)
            {
                _this.editFormNode.querySelector('.response-text').innerHTML = data.d.HTML;
                
                if (data.d.Status) {
                    _this.editFormNode.querySelector('input[type="submit"]').style.display = 'none';
                }
            }
        });
    }

    deleteGalleryImage(imId) {
        let _this = this;
        
        let imgNode = this.fieldImgGalleryNode.querySelector('[data-imid="' + imId + '"]');
        imgNode.classList.add('busy');
        
        let submittedData = {
            data: {
                CheckField: _this.editFormNode.querySelector('input[name="CheckField"]').value,
                CheckRequest: _this.editFormNode.querySelector('input[name="CheckRequest"]').value,
                CoId: _this.editFormNode.querySelector('input[name="CoId"]').value,
                ImId: parseInt(imId)
            }
        };
        
        $.ajax({
            type: 'POST',
            url: '/ws/wsAreaEditContenuti.asmx/DeleteGalleryImage',
            cache: false,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(submittedData),
            dataType: 'json',
            success: function(data) {
                if (data.d.Status) {
                    imgNode.parentNode.removeChild(imgNode);
                }
            },
            complete: function() {
                imgNode.classList.remove('busy');
            }
        });
    }

    uploadGalleryImage() {
        let _this = this;
        
        let imgTpl = this.fieldImgGalleryNode.querySelector('[data-img-tpl]').cloneNode(true);
        imgTpl.removeAttribute('data-img-tpl');
        imgTpl.removeAttribute('style');

        let selectedFile = this.fieldImgGalleryNode.querySelector('.img-gallery-upload-file').files[0];
        let imgGrid = this.fieldImgGalleryNode.querySelector('.img-grid');

        this.editFormNode.classList.add('busy');

        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);
        fileReader.addEventListener("load", function() {
            let submittedData = {
                data: {
                    CheckField: _this.editFormNode.querySelector('input[name="CheckField"]').value,
                    CheckRequest: _this.editFormNode.querySelector('input[name="CheckRequest"]').value,
                    CoId: _this.editFormNode.querySelector('input[name="CoId"]').value,
                    imgType: _this.fieldImgGalleryNode.querySelector('[data-img-gallery-upload]').dataset.imgType,
                    filename: selectedFile.name,
                    base64: fileReader.result,
                },
            };

            let responseData = {};

            $.ajax({
                type: 'POST',
                url: '/ws/wsAreaEditContenuti.asmx/UploadGalleryImage',
                cache: false,
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submittedData),
                dataType: 'json',
                success: function(data) {
                    responseData = data;
                    
                    let newImgNode = imgTpl.cloneNode(true);
                    newImgNode.setAttribute('data-imid', responseData.d.Props.imId);
                    newImgNode.querySelector('img').setAttribute('src', responseData.d.Props.imageURL);
                    newImgNode.querySelector('[name="Delete"]').setAttribute('data-img-gallery-delete', responseData.d.Props.imId);

                    imgGrid.appendChild(newImgNode);
                },
                complete: function() {
                    console.log(responseData);
                    _this.editFormNode.classList.remove('busy');
                }
            });
        }, false);
    }

    cropImage() {
        let _this = this;
        let responseData = {};
        let cropButton = this.fieldImgNode.querySelector('[data-img-crop]');
        
        let cropperData = _this.cropper.getData(true);

        let submittedData = {
            data: {
                CheckField: _this.editFormNode.querySelector('input[name="CheckField"]').value,
                CheckRequest: _this.editFormNode.querySelector('input[name="CheckRequest"]').value,
                ImId: _this.editFormNode.querySelector('input[name="ImId"]').value,
                cropperTargetWidth: cropButton.dataset.cropWidth,
                cropperTargetHeight: cropButton.dataset.cropHeight,
                cropperX: cropperData.x,
                cropperY: cropperData.y,
                cropperWidth: cropperData.width,
                cropperHeight: cropperData.height   
            }
        };
        
        _this.editFormNode.classList.add('busy');
        _this.editFormNode.querySelector('.img-upload-img img').setAttribute('src', '/docs/assets/img/ajax-loader.gif');

        $.ajax({
            type: 'POST',
            url: "/WS/wsAreaEditContenuti.asmx/CropImage",
            cache: false,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(submittedData),
            dataType: 'json',
            success: function(data) {
                responseData = data;

                _this.editFormNode.querySelector('.img-upload-img img').setAttribute('src', responseData.d.Props.imageURL);
                
                // Nascondi Croop tool.
                if (window.cropToolEnabled) {
                    _this.cropper.destroy();
                    _this.fieldImgNode.querySelector('.img-upload-crop-wrapper').style.display = 'none';   
                }

                // Mostra Legenda Pin Tool e reset pin.
                if (window.pinToolEnabled) {
                    _this.editFormNode.querySelector('.img-upload-legenda').style.display = 'block';
                    // @see PinTool.cshtml
                    initPinTool(_this.editFormNode.querySelector('input[name="CoId"]').value, responseData.d.Props.imId);
                }
            },
            complete: function() {
                _this.editFormNode.classList.remove('busy');
            }
        });
    }

    uploadImage() {
        let _this = this;
        let responseData = {};
        let uploadButton = this.fieldImgNode.querySelector('[data-img-upload]');
        let selectedFile = this.fieldImgNode.querySelector('.img-upload-file').files[0];

        this.editFormNode.classList.add('busy');
        _this.editFormNode.querySelector('.img-upload-img img').setAttribute('src', '/docs/assets/img/ajax-loader.gif');

        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);
        fileReader.addEventListener("load", function() {
            let submittedData = {
                data: {
                    CheckField: _this.editFormNode.querySelector('input[name="CheckField"]').value,
                    CheckRequest: _this.editFormNode.querySelector('input[name="CheckRequest"]').value,
                    CoId: _this.editFormNode.querySelector('input[name="CoId"]').value,
                    ImId: _this.editFormNode.querySelector('input[name="ImId"]').value,
                    imgType: uploadButton.dataset.imgType,
                    filename: selectedFile.name,
                    base64: fileReader.result,   
                },
            };

            $.ajax({
                type: 'POST',
                url: '/ws/wsAreaEditContenuti.asmx/UploadImage',
                cache: false,
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submittedData),
                dataType: 'json',
                success: function(data) {
                    responseData = data;

                    _this.editFormNode.querySelector('.img-upload-img img').setAttribute('src', responseData.d.Props.imageURL);
                    _this.editFormNode.querySelector('[name="ImId"]').setAttribute('value', responseData.d.Props.imId);
                    uploadButton.setAttribute('value', uploadButton.dataset.txtSostituisci);

                    // Mostra cropper tool.
                    if (window.cropToolEnabled) {
                        let aspectRatio = _this.fieldImgNode.querySelector('[data-img-crop]').dataset.cropWidth /
                            _this.fieldImgNode.querySelector('[data-img-crop]').dataset.cropHeight;
                        
                        _this.cropper = new Cropper(_this.editFormNode.querySelector('.img-upload-img img'), {
                            aspectRatio: aspectRatio,
                            cropBoxMovable: true
                        });
                        
                        _this.fieldImgNode.querySelector('.img-upload-crop-wrapper').style.display = 'block';   
                    }

                    // Nascondi Legenda Pin Tool e reset pin.
                    if (window.pinToolEnabled) {
                        _this.editFormNode.querySelector('.img-upload-legenda').style.display = 'none';
                        // @see PinTool.cshtml
                        initPinTool(_this.editFormNode.querySelector('input[name="CoId"]').value, responseData.d.Props.imId);   
                    }
                },
                complete: function() {
                    console.log(responseData);
                    _this.editFormNode.classList.remove('busy');
                }
            });
        }, false);
    }
    
    addCKEditor() {
        this.CKEditor = CKEDITOR.inline(this.editFormNode.querySelector('[name="CoBody"]'), {
            toolbar: "light",
            toolbar_light: [
                { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'RemoveFormat'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                { name: 'styles', items: ['Styles'] },
            ],
            stylesSet: [
                { name: 'Small title', element: 'div', attributes: { 'class': 'tit extrasmall' } }
            ]
        });
    }

    static init() {
        let editContenuto = document.querySelector("[data-edit-contenuto]");

        if (editContenuto) {
            return new AreaEditContenutiEdit(editContenuto);
        }
    }
}